/* React hooks */
import {useEffect, useState} from "react";
/* Components */
import useData from "../../../hooks/useData";
import FormInputs from "../../FormInputs";
import useAuth from "../../../hooks/useAuth";
import {useParams} from "react-router-dom";
import {updateNetworkContact} from "../../../api/admin/networkReq";
import {getCountryList} from "../../../api/admin/addressReq";
import FormButtons from "../../../components/common/FormButtons";
import {
    checkRequiredFields,
    getErrorListFromValidation, normalizeZipCode,
    patternListChoices,
    removeErrorList,
    validateFormInput
} from "../../../helper/tools";
import InputFullAddress from "../../../components/common/input-layout/InputFullAddress";
import Icon from "../../../components/common/Icon";


export default function FormNetworkContact({ setShowModal, legend, apiNetworkContactInfos }) {
    const { auth } = useAuth();
    const token = auth.token;
    const { id } = useParams();
    const {countryList, setCountryList} = useData();
    const [values, setValues] = useState({});
    const { networkContact } = useData();
    const { selectedCity } = useData();

    useEffect(() => {
        if (selectedCity && (selectedCity.zip || selectedCity.name)) {
            setValues(prevValues => ({
                ...prevValues,
                address: {
                    ...prevValues.address,
                    zipcode: selectedCity.zip,
                    city: selectedCity.name
                }
            }));
        }
    }, [selectedCity]);

    const onChange = (e) => {
        setValues({...values, [e.target.name] : e.target.value})
        validateFormInput(e)
    };

    const onChangeAddress = (e) => {
        setValues({...values, address : {...values?.address, [e.target.name] : e.target.value}})
        validateFormInput(e)
    }

    const apiCountryList = async () => {
        const response = await getCountryList(token)
        setCountryList(response)
    }

    const optionCountryList = countryList?.map(country => (
        { [country?.code] : [country?.name] }
    ));

    useEffect(() => {
        if (networkContact) {
            setValues(networkContact);
        }
    }, [networkContact]);

    useEffect(() => {
        apiCountryList()
    }, []);

    const inputs = [
        {
            id : 6,
            name : "phone",
            type : "text",
            placeholder : "Téléphone",
            label : "Téléphone",
            pattern : patternListChoices?.phone,
        },
        {
            id : 7,
            name : "email",
            type : "email",
            placeholder : "Email",
            label : "Email",
            required : true,
        },
        {
            id : 8,
            name : "website",
            type : "text",
            placeholder : "Site Internet",
            label : "Site Internet",
            pattern: patternListChoices?.url
        },
    ];

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (!checkRequiredFields()) {
            return;
        }
        let body = {
            networkId : id,
            address : {
                addressId : values?.address?.addressId,
                address : values?.address?.address,
                addressComp : values?.address?.addressComp,
                zipcode : normalizeZipCode(values?.address?.zipcode),
                city : values?.address?.city,
                country : values?.address?.country,
                latitude : values?.address?.latitude,
                longitude : values?.address?.longitude,
            },
            phone : values?.phone,
            email : values?.email,
            website : values?.website,
            defaultOpt : values?.defaultOpt,
        }

        await updateNetworkContact(token, body)
            .then(response => {
                removeErrorList();
                if (!response?.response?.data?.error) {
                    setShowModal(false)
                    apiNetworkContactInfos()
                } else {
                    getErrorListFromValidation(response?.response?.data?.error)
                }
            })
    }

    const handleRemoveModal = () => {
        setShowModal(false)
    };

    return (
        <form onSubmit={handleSubmit} method="post" id="form-network-contact">
            <fieldset>
                {(legend !== "no-legend") && <Icon source="fa-solid fa-address-book" span={legend} />}
                <InputFullAddress
                    addressField="address"
                    compField="addressComp"
                    zipField="zipcode"
                    cityField="city"
                    countryField="country"
                    address={values?.address?.address}
                    comp={values?.address?.addressComp}
                    zipcode={values?.address?.zipcode}
                    city={values?.address?.city}
                    country={values?.address?.country}
                    onChange={onChangeAddress}
                    options={optionCountryList}
                    selected={values?.address?.country}
                    required={true}
                    type="actual"
                />
                <div className="form-input">
                    <label htmlFor="latitude" className="required">Latitude</label>
                    <input type="text" name="latitude" pattern={patternListChoices?.latitude} value={values?.address?.latitude} onChange={onChangeAddress} required/>
                </div>
                <div className="form-input">
                    <label htmlFor="longitude" className="required">Longitude</label>
                    <input type="text" name="longitude" pattern={patternListChoices?.longitude} value={values?.address?.longitude} onChange={onChangeAddress} required/>
                </div>
                {inputs.map(input =>(
                    <FormInputs
                        type={ input.type }
                        name={ input.name }
                        id={ input.id }
                        label={input.label}
                        placeholder={ input.placeholder }
                        value={ values?.[input.name] }
                        onChange={ onChange }
                        required={ input.required }
                        options={ input.options }
                        selected={ input.selected }
                        checked={ input.checked }
                        key={ input.id+input.name }
                        pattern={ input.pattern }
                        defaultOpt={ input.defaultOpt }
                        defaultOptName={ input.defaultOptName }
                    />
                ))}
                <div className="errors"></div>
            </fieldset>
            <FormButtons handleRemoveModal={handleRemoveModal}/>
        </form>
    )
}